module.exports = __webpack_public_path__ + "img/jpm_icons2.ec87bc2f.png";